import { ADD_INSPECTION, INSPECTION_PLANT_DATA, INSPECTION_UNITS, SET_BBOX, SET_SAMPLE_IMAGES, SET_SELECTED_DEFECT, TOGGLE_DRAW_MODE, TOGGLE_DISAGREE_MODE, SET_SELECTED_REASON, SET_PREDICTION_LABELS, SET_UNIT_COUNT, CANVAS_HEIGHT, SET_CRITERIA_SUMMARY, TOGGLE_PASSRESUME_MODE, TOGGLE_PASSRESUME_CLICK_MODE, SET_CRITERIA_LOGS, LOG_CATEGORY_EVENT, CLEAR_CATEGORY_EVENTS, SET_STATUS_TEXT } from "./types";

const MAX_EVENTS = 500;

const initialState = {
  inspections: [],
  isDrawModeActive: false,
  isDisagreeModeActive: false,
  selectedReason: null,
  sampleImages: [],
  factoryNane: '',
  bbox: {
    minX: null,
    minY: null,
    maxX: null,
    maxY: null
  },
  plantList: null,
  criteriaSummary: [],
  unitCount: 0,
  totalCount: 0,
  categoryCriteria: {},
  categoryEvents: [],
  statusText: "",
  isPassResumeActive: false,
  isPassResumeClickActive: false,
};

const inspectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_INSPECTION:
      return { ...state, inspections: action.payload }

    case INSPECTION_UNITS:
      return { ...state, inspection_unit: action.payload }

    case TOGGLE_DRAW_MODE:
      return { ...state, isDrawModeActive: action.payload };

    case TOGGLE_DISAGREE_MODE:
      return {
        ...state,
        isDisagreeModeActive:
          typeof action.payload === "boolean"
            ? action.payload
            : !state.isDisagreeModeActive,
      };

    case TOGGLE_PASSRESUME_MODE:
      return {
        ...state,
        isPassResumeActive:
          typeof action.payload === "boolean"
            ? action.payload
            : !state.isPassResumeActive,
      };

    case TOGGLE_PASSRESUME_CLICK_MODE:
      return { ...state, isPassResumeClickActive: action.payload }

    case SET_SELECTED_REASON:
      return { ...state, selectedReason: action.payload };

    case SET_SAMPLE_IMAGES:
      return { ...state, sampleImages: action.payload };

    case SET_BBOX:
      console.log('stateee', state);
      return {
        ...state, bbox: { ...state.bbox, ...action.payload }
        // ...state,bbox: [state.bbox,{...action.payload }]
      };
    case SET_SELECTED_DEFECT:
      return { ...state, selectedDefect: action.payload };

    case 'factoryname':
      return { ...state, factoryname: action.payload };

    case INSPECTION_PLANT_DATA:
      return { ...state, plantList: action.payload };
    case SET_PREDICTION_LABELS:
      return { ...state, predictionLabels: action.payload };

    case SET_UNIT_COUNT: {
      const p = action.payload;
      if (typeof p === "number") {
        return { ...state, unitCount: p };
      }
      const inspected = Number(p?.inspected ?? state.unitCount ?? 0);
      const total = Number(p?.total ?? state.totalCount ?? 0);

      return {
        ...state,
        unitCount: inspected,
        totalCount: total,
      };
    }

    case CANVAS_HEIGHT:
      return { ...state, canvasHeight: action.payload };

    case SET_CRITERIA_SUMMARY:
      return { ...state, criteriaSummary: action.payload };

    case SET_CRITERIA_LOGS:
      return { ...state, criteriaLogs: action.payload };

    case LOG_CATEGORY_EVENT: {
      const events = [...state.categoryEvents, action.payload];
      if (events.length > MAX_EVENTS) events.shift();
      return { ...state, categoryEvents: events };
    }

    case CLEAR_CATEGORY_EVENTS:
      return { ...state, categoryEvents: [] };

    case SET_STATUS_TEXT:
      return { ...state, statusText: action.payload };



    default:
      return state;
  }

};

export default inspectionReducer;
